
export const TZ = 'Europe/Paris';

export const fmtDT = (d) =>
    new Intl.DateTimeFormat('fr-FR', {
        dateStyle: 'medium',
        timeStyle: 'medium',
        timeZone: TZ,
    }).format(d);

export const toMs = (n) => (n < 1e12 ? n * 1000 : n);

export const safeDate = (v) => {
    if (v == null) return null;
    if (typeof v === 'number') return new Date(toMs(v));
    const n = Number(v);
    if (!Number.isNaN(n)) return new Date(toMs(n));
    const d = new Date(v);
    return Number.isNaN(d.getTime()) ? null : d;
};

export function normalizeAndSort(arr, field) {
    const copy = Array.isArray(arr) ? [...arr] : [];
    copy.sort((a, b) => {
        const ta = safeDate(a?.[field])?.getTime() ?? -Infinity;
        const tb = safeDate(b?.[field])?.getTime() ?? -Infinity;
        return tb - ta; // desc
    });
    return copy;
}

export function hashSnapshot(items, UPDATED_FIELD) {
    const key = JSON.stringify(
        (items || []).map((it) => ({
            u: it.uuid ?? it.id ?? null,
            t: safeDate(it[UPDATED_FIELD])?.getTime() ?? null,
            s: !!it.synced,             // <— include sync state
            c: Number(it.scan_count) || 0 // <— and scan counter
        })),
    );
    let h = 0;
    for (let i = 0; i < key.length; i++) h = ((h << 5) - h) + key.charCodeAt(i) | 0;
    return String(h);
}

/****** SIMULATOR LOGS ******/
function esc(s) {
    return String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
}

export function appendSimLog({ status = 'info', message = '', uuid = '', type = '' } = {}) {
    const color = status === 'danger' ? 'danger'
        : status === 'warning' ? 'warning'
            : status === 'success' ? 'success'
                : 'secondary';
    // Sélection souple du conteneur (par device si dispo), sinon fallback global
    const dev = (window.SIM_DEVICE_ID ? document.querySelector(`[data-sim-device-log="${window.SIM_DEVICE_ID}"]`) : null)
        || (window.SIM_DEVICE_ID ? document.getElementById(`device-log-${window.SIM_DEVICE_ID}`) : null)
        || document.getElementById('simDeviceLog')
        || document.getElementById('deviceLogList');
    if (!dev) {
        // Fallback console si pas de container dans le DOM
        const fn = color === 'danger' ? 'error' : color === 'warning' ? 'warn' : 'log';
        console[fn](`[sim] ${status.toUpperCase()}: ${message}`, uuid, type);
        return;
    }

    const li_uuid = document.createElement('li');
    li_uuid.className = 'list-group-item d-flex justify-content-between align-items-center';

    if (uuid) {
        li_uuid.innerHTML = `<div>Scanning ${uuid}...</div>`;
        dev.prepend(li_uuid);
    }

    const li_message = document.createElement('li');
    li_message.className = 'list-group-item d-flex justify-content-between align-items-center';
    li_message.innerHTML = `
        <div class="badge rounded-pill text-bg-${color} me-2">${esc(status)}</div>
        <div>${esc(message)}</div>
        ${type ? `<div class="ms-2 text-body-secondary">(${esc(type)})</div>` : ''}
    `;
    dev.prepend(li_message);

    // Garde la liste compacte
    const MAX = 100;
    while (dev.children.length > MAX) dev.removeChild(dev.lastElementChild);
}
